/**
 * @generated SignedSource<<9144716dc18295ddf34b6b5420d2f093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATInternalPhoneNumberUpdateInput = {
  id: string;
  phoneNumber: string;
};
export type InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation$variables = {
  input: MATInternalPhoneNumberUpdateInput;
};
export type InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation$data = {
  readonly internalPhoneNumberUpdate: {
    readonly id: string;
    readonly phoneNumber: string | null;
  };
};
export type InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation = {
  response: InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation$data;
  variables: InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATInternalUser",
    "kind": "LinkedField",
    "name": "internalPhoneNumberUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "phoneNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "687f8336eac6ba9b7650ce364ca09250",
    "id": null,
    "metadata": {},
    "name": "InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation InternalUserPhoneNumberUpdateDialog_internalUserPhoneNumberUpdateMutation(\n  $input: MATInternalPhoneNumberUpdateInput!\n) {\n  internalPhoneNumberUpdate(input: $input) {\n    id\n    phoneNumber\n  }\n}\n"
  }
};
})();

(node as any).hash = "153ea1080a1e861b013ecf9d39551323";

export default node;
